export function parentUntil (dom, parentClassName) {
  let parent = dom
  while (!parent.classList.contains(parentClassName) && parent.node.nodeName !== 'BODY') {
    parent = parent.parentElement || parent.parentNode
  }
  if (parent.classList.contains(parentClassName)) {
    return parent
  }
  return null
}

export function createScreenOutElement (text) {
  var isRTL = document.documentElement.getAttribute('dir') === 'rtl';
  var element = document.createElement('textarea');
  // 防止在ios中产生缩放效果
  element.style.fontSize = '12pt';
  // 重置盒模型
  element.style.border = '0';
  element.style.padding = '0';
  element.style.margin = '0';
  // 将元素移到屏幕外
  element.style.position = 'absolute';
  element.style[isRTL ? 'right' : 'left'] = '-9999px';
  // 移动元素到页面底部
  let yPosition = window.pageYOffset || document.documentElement.scrollTop;
  element.style.top = `${yPosition}px`;
  //设置元素只读
  element.setAttribute('readonly', '');
  element.value = text;
  document.body.appendChild(element);

  return element
}

export function getElementsByClassName (className) {
  let els = [];
  for (let el of document.getElementsByClassName(className) || []) {
    els.push(el);
  }
  return els;
}

export function loadCss(url) {
  return new Promise((resolve, reject) => {
    const link = document.createElement('link');
    link.href = url;
    link.rel = 'preload';
    link.as = 'style';
    link.onload = () => {
      link.rel = 'stylesheet';
      resolve(); // CSS加载完成
    };
    link.onerror = reject; // 加载失败
    document.head.appendChild(link);
  });
}


export function clearCss(url) {
  const links = document.querySelectorAll('link');
  for (let link of links) {
    if (link.href === url) {
      document.head.removeChild(link);
    }
  }
}

export function isElementInViewport(el, maskPanelHeight = 0) {
  const rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom + maskPanelHeight <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

// 获取rtc音量图标高度
export function getRtcVolumeIconHeight(volume, iconHeight) {
  return ((volume - 60) / 40) * iconHeight + 6
}